// extracted by mini-css-extract-plugin
export default {"wrapper":"PasswordIcon_wrapper__fga59"};